import * as React from "react";
import {ChangeEvent} from "react";
import {Portal} from "react-portal";
import HtmlWidgetControls from "./HTMLWidgetControls";
import { moveContainerStyles } from "shared/ui/common/styles";

interface HtmlWidgetProps {
    isSelected: boolean;
    readOnly: boolean;
    isTransforming: boolean;
    htmlText?: string;
    onChange: (text: string) => void;
    onSelect: (event: React.MouseEvent) => void;
    onDeselect: () => void;
    onMount: () => void;
}
interface HtmlWidgetState {
    htmlText: string;
}

class HtmlWidget extends React.Component<HtmlWidgetProps, HtmlWidgetState> {
    constructor(props: HtmlWidgetProps) {
        super(props);
    }

    handleDragContainerMouseDown = (event: React.MouseEvent<HTMLElement>) => {
        this.props.onSelect(event);
    }

    onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        this.props.onChange(event.target.textContent);
    }

    render() {
        const {isSelected} = this.props;
        const portalTarget = document && document.getElementById("character-properties");

        return (
            <>
                {isSelected && portalTarget && (
                    <Portal node={portalTarget}>
                        <div>
                            <HtmlWidgetControls onChange={this.onChange} htmlText={this.props.htmlText}/>
                        </div>
                    </Portal>
                )}
                <div
                    className={"drag-container"}
                    style={moveContainerStyles}
                    onMouseDown={this.handleDragContainerMouseDown}
                />
            </>
        );
    }
}

// noinspection JSUnusedGlobalSymbols
export {HtmlWidget as default, HtmlWidget};



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/htmlWidget/HTMLWidgetComponent.tsx